{
  "name": "project-name",
  "version": "1.0.76",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "aotfalsebuild": "ng build --configuration=$npm_config_env --aot=false",
    "aotbuild": "ng build --configuration=$npm_config_env",
    "build-deploy": "npm-run-all aotfalsebuild"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.1.3",
    "@angular/cdk": "22.1.3",
    "@angular/common": "22.1.3",
    "@angular/compiler": "22.1.3",
    "@angular/core": "22.1.3",
    "@angular/forms": "22.1.3",
    "@angular/google-maps": "22.1.3",
    "@angular/material": "22.1.3",
    "@angular/platform-browser": "22.1.3",
    "@angular/platform-browser-dynamic": "22.1.3",
    "@angular/router": "22.1.3",
    "@auth0/angular-jwt": "^5.2.0",
    "@delhivery/auth": "22.0.0",
    "@fortawesome/fontawesome-free": "^5.12.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@syncfusion/ej2-angular-inputs": "^25.1.35",
    "angular-oauth2-oidc": "^22.0.0",
    "autoprefixer": "10.5.4",
    "bootstrap": "^4.3.1",
    "howler": "^2.1.3",
    "jwt-decode": "^4.0.0",
    "material-design-icons": "^3.0.1",
    "ngx-cookie": "^6.0.1",
    "ngx-toastr": "^20.0.5",
    "postcss": "8.5.25",
    "rxjs": "~7.8.1",
    "tailwindcss": "3.4.19",
    "tslib": "2.8.1",
    "zone.js": "0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.1.5",
    "@angular-eslint/builder": "22.5.0",
    "@angular-eslint/eslint-plugin": "22.5.0",
    "@angular-eslint/eslint-plugin-template": "22.5.0",
    "@angular-eslint/schematics": "22.5.0",
    "@angular-eslint/template-parser": "22.5.0",
    "@angular/cli": "22.1.5",
    "@angular/compiler-cli": "22.1.3",
    "@angular/language-service": "22.1.3",
    "@eslint/js": "^10.0.1",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^20.11.0",
    "@typescript-eslint/eslint-plugin": "8.70.0",
    "@typescript-eslint/parser": "8.70.0",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.10.0",
    "jasmine-core": "~5.1.2",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.2.0",
    "sass": "^1.32.0",
    "ts-node": "~10.9.2",
    "typescript": "~6.0.0",
    "typescript-eslint": "^8.70.0"
  }
}
